import {Component, computed, OnInit, input, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {NativeCheckboxComponent} from "@common/components/inputs/native/native-checkbox/native-checkbox.component"
import {FiltersService} from "@common/services/filters/filters.service"
import {StateLabel} from "@labels"
import {forceSetValue, setsAreEqual} from "@common/helpers/utils/set"
import {filter, map} from "rxjs"
import {PlaceholderComponent} from "@common/components/placeholders/placeholder/placeholder.component"

/**
 * Multiple checkboxes used to toggle options for a single filter criterion
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-checkboxes-filter",
    templateUrl: "./checkboxes-filter.component.html",
    styleUrls: ["./checkboxes-filter.component.scss"],
    imports: [NativeCheckboxComponent, PlaceholderComponent],
})
export class CheckboxesFilterComponent implements OnInit {
    readonly $label = input("", {alias: "label"})
    readonly $name = input<string>("", {alias: "name"})
    readonly $options = input<StateLabel<string>[] | Map<string, StateLabel<string>> | null>(null, {alias: "options"})
    readonly $resolvedOptions = computed<StateLabel<string>[] | null>(() => {
        const value = this.$options()
        if (value instanceof Map) {
            return Array.from(value.values())
        }
        return value
    })

    readonly $selectedOptions = signal(new Set<string>())

    public onCheckboxToggled = (option: string, value: boolean) => {
        forceSetValue(this.$selectedOptions(), option, value)
        void this.filtersService.updateCriteria(this.$name(), this.$selectedOptions())
    }
    private readonly filtersService = inject(FiltersService)

    constructor() {
        this.filtersService.states
            .pipe(
                map((states) => states.criteria[this.$name()]),
                filter((selection) => !setsAreEqual(selection, this.$selectedOptions())),
            )
            .subscribe((selection) => {
                this.$selectedOptions.set(selection ?? new Set())
            })
    }

    ngOnInit() {
        this.filtersService.currentStates.criteria[this.$name()]?.forEach((option) => forceSetValue(this.$selectedOptions(), option, true))
    }
}
